import Vue from "vue";
import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      updatingPrices: false,
    }),
    mutations: {
      setUpdatingPrices(state, item) {
        state.updatingPrices = item
      },
    },
    actions: {
        async updateAllFencePrices( { commit, dispatch }, payload) {
          commit("setUpdatingPrices", true);
          let url = process.env.VUE_APP_HUB_API_HOST + `api/manufacturing/fence/prices/`;
          let fetchFuncName = 'fetchModeleGard'

          if (payload.priceType == 'configurator') {
            url += 'configurator/'
            fetchFuncName = 'fences/fetchPricesConfigurator'
          }
          url += `update/${payload.country}`

          const body = {
            percent: payload.percent,
            ...(payload.models ? { models: payload.models } : {})
          }

          try {
            const response = await Vue.http.post(url, body, {
              headers: headers
            });
            dispatch(fetchFuncName, payload.country, { root: true })
            commit("setUpdatingPrices", false);
            router.push({ query: M.toast( { html: response.body.message, classes: "bg-green-500" }) });
          } catch (error) {
            console.log(error);
            commit("setUpdatingPrices", false);
          }
        }
    }
}